// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill'
// 火山引擎
import './utils/trace/volcengine'

import "requestidlecallback-polyfill";
import Vue from 'vue'
import moment from 'moment';
import ElementUI from 'element-ui'
import Message from './components/Message'
import ColorPicker from './components/el-color-picker';
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import 'animate.css'
// import vuex from 'vuex'
import store from './store/index'
import vuescroll from 'vuescroll'
import 'vuescroll/dist/vuescroll.css'
import Components from './components/common/index'
import i18n from './i18n/i18n'
import bus from './components/common/bus'
import { transLightToProp } from './utils/actionsHandler';
import { APP_SHOW_MODE_ENUM,UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY,UICONTROL_CX_CY_WithMode_ARRAY, PROJECTTYPE_ENUM} from '@/utils/enums'
// 引入mockjs
// import echarts from 'echarts'

import './utils/rem.js'
import './utils/trace/windowLifeTrace'
import './utils/trace/performanceTrace'
import './utils/trace/vueTrace'
import './utils/trace/sensors'

// highcharts3d(highchart);

// Vue.prototype.$Highcharts = highchart

import vRometeJs from 'v-remote-js'
// import axios from 'axios'

// Vue.prototype.$icons = (param)=>{return '';};
// import oppleIcons from "@opple/commercial-lighting-resource/JS/Icons.js";
import oppleIcons from '../static/@opple/commercial-lighting-resource/JS/Icons.js'

import Es6Promise from 'es6-promise'
import summerTimeOffset from '@utils/summerTimeOffset'
import { getAppShowMode } from '@utils/utils'
import OppleAuth from '@/components/OppleAuth/index.vue'
import OpDeviceChoose from '@/components/common/OpDeviceChoose.vue';
import imgListData from '@/i18n/langs/imgDataList';
import VueDragscroll from 'vue-dragscroll'

import './xingChengMessage.js';
import { initXingCheng  } from './xingChengMessage.js';

import { routeHighlightMap }  from '@/utils/enums.js'


Vue.component('OppleAuth', OppleAuth);
Vue.component('OpDeviceChoose', OpDeviceChoose);
Vue.use(vRometeJs)
Vue.use(VueDragscroll)

// 大的包不要挂在原型上, 会使首屏加载的js很大 
// Vue.prototype.$echarts = echarts

Vue.use(Components)
// Vue.prototype.$axios = axios
Vue.prototype.$icons = oppleIcons
Vue.prototype.$TIME_STAMP = process.env.VUE_APP_TIME_STAMP // 项目构建时间

Vue.prototype.$img = (imgKey) => {
  const lang = getLocalStoragItem('lang');
  // 'en-us' 'de' 'zh-cn'
  // const imgListData = {
  //   elfNotice1: {
  //     e: 'https://appresource.opple.com/media/business/2379/20240425113718_62.png',
  //     d: 'https://appresource.opple.com/media/business/2379/20240425113814_47.png',
  //     z: 'https://appresource.opple.com/media/panel/2023/09/12/20230912185546_90.png',
  //   },
  //   elfNotice2: {
  //     e: 'https://appresource.opple.com/media/business/58/20240425112927_79.png',
  //     d: 'https://appresource.opple.com/media/business/2379/20240425113527_16.png',
  //     z: 'https://appresource.opple.com/media/panel/2023/09/12/20230912185546_90.png',
  //   }, 
  // }

  const imgData = imgListData[imgKey];

  if (!imgData) return;

  switch (lang) {
    case 'en-us':
      return imgData.e || '';
    case 'de':
      return imgData.d || '';
    case 'zh-cn':
      return imgData.z || '';
    case 'fr':
      return imgData.fr || '';
    default:
      return imgData.z || '';
  }
}

Vue.config.warnHandler = function(msg, vm, trace) {
  if (msg.includes('"style" is a reserved attribute')) {
    return // 忽略这个警告
  }
  console.warn('[Vue warn]: ' + msg + '\n' + trace)
}

// var script = document.createElement("script");
// script.type = "text/javascript";
// script.src = "https://webapi.amap.com/maps?v=1.4.15&key=97c6e27fb0a47a9a66959a5384f87783&plugin=AMap.Autocomplete,AMap.PlaceSearch";
// document.body.appendChild(script);
// script = document.createElement("script");
// script.type = "text/javascript";
// script.src = "http://api.map.baidu.com/api?type=webgl&v=1.0&ak=bKmMydK9AwCCC3nKgmpzlgMGrELW30DH";
// document.body.appendChild(script);
// script = null;

// 你可以在这里设置全局配置
Vue.use(vuescroll, {
  ops: {
    vuescroll: {
      mode: 'native',
      sizeStrategy: 'number ',
      detectResize: true
    },
    scrollPanel: {
      initialScrollY: false,
      initialScrollX: false,
      scrollingX: false,
      scrollingY: true,
      speed: 300,
      easing: undefined,
      verticalNativeBarPos: 'right'
    },
    rail: {
      background: '#01a99a',
      opacity: 0,
      size: '6px',
      specifyBorderRadius: false,
      gutterOfEnds: null,
      gutterOfSide: '2px',
      keepShow: false
    },
    bar: {
      showDelay: 500,
      onlyShowBarOnScroll: true,
      keepShow: false,
      background: '#c1c1c1',
      opacity: 1,
      hoverStyle: false,
      specifyBorderRadius: false,
      minSize: 0,
      size: '3px',
      disable: false
    }
  }, // 在这里设置全局默认配置
  name: 'myScroll' // 在这里自定义组件名字，默认是vueScroll
})

// Vue.use(animated)
Vue.use(ElementUI, {
  size: 'small'
})
Vue.component(ColorPicker.name, ColorPicker);
Vue.prototype.$message = Message
// Vue.use(vuex)
Vue.config.productionTip = false
Vue.prototype.systemNoticesTipsWindowClose = function (param) {
  document.getElementById('systemNoticesTipsWindow').style.display = param ? 'none' : 'flex'
}
Vue.prototype.verificationblank = function (that) {
  // console.log(getLocalStoragItem('projectcode'));
  let _url = window.location.href
  let notice
  if (_url != null && _url.indexOf('invitehandle') === -1 && _url.indexOf('qrcodecontrol') === -1) {
    if (getLocalStoragItem('projectcode') === '' || getLocalStoragItem('projectcode') === undefined || getLocalStoragItem('projectcode') == null) {
      if(!store.state.token || !getLocalStoragItem('token')) {
        that.$router.push({
          name: 'login'
        })
      } else {
        that.$router.push({
          name: 'projectDetails'
        })
        that.$store.dispatch('changeRoutermsg', '/projectDetails')
      }
    } else {
      _url = that.$router.history.pending
      _url = _url || that.$route
      if (_url != null && _url.fullPath != null) {
        that.$store.dispatch('changeRoutermsg', routeHighlightMap[_url.fullPath] || _url.fullPath)
        // '/ai-paint'
        if (['/3dc'].includes(_url.fullPath)) {
          setTimeout(param => {
            bus.$emit('noborder', true)
          }, 100)
        } else {
          setTimeout(param => {
            bus.$emit('noborder', false)
          }, 100)
        }
      }
    }
  }
  notice = that.$store
  notice = notice && notice.state
  notice = notice && notice.systemNotices
  _url = that.$router.history.pending
  _url = _url || that.$route
  if (notice != null && _url != null && _url.fullPath) {
    notice = notice.find(url => {
      return url.path != null && url.path === _url.fullPath
    })
    if (notice != null && notice.disabled !== true) {
      _url = window.localStorage
      if (that.$store.state.systemNoticesReset === true) {
        window.localStorage.setItem('systemNotices', null)
        _url = null
      } else {
        _url = _url && _url.getItem('systemNotices')
      }
      if (_url != null && !JSON.isJSON(_url)) {
        _url = null
      }
      _url = _url && JSON.parse(_url)
      if (_url == null || _url.indexOf(notice.path) < 0) {
        that.systemNoticesTipsWindowClose(false)
      }
    }
  }
  notice = null
  _url = null
}
Vue.prototype.getPermission = function (_str, key) {
  let rt = -1
  if (_str !== '') {
    if (getLocalStoragItem('userinfor') != null && getLocalStoragItem('userinfor') !== '') {
      const strUser = JSON.parse(getLocalStoragItem('userinfor'))
      // console.log(strUser.Power, 'strUser=========>', _str, key == null)
      if (key == null) {
        if (strUser.Power != null) {
          if (_str.indexOf(',') !== -1) {
            // 多个
            const list = _str.split(',')
            let ishas = false
            for (const _index in list) {
              if (strUser.Power.indexOf(getFinalStr(list[_index])) !== -1) {
                ishas = true
              }
            }
            if (ishas) {
              rt = 1
            }
          } else {
            // 单个
            rt = strUser.Power.indexOf(getFinalStr(_str))
          }
        }
      } else if (strUser.UserRole != null && strUser.UserRole >= 4) {
          _str += ''
          if (strUser[key] != null) {
            if (_str.indexOf(',') !== -1) {
              // 多个
              const list = _str.split(',')
              let ishas = false
              for (const _index in list) {
                if (strUser[key].indexOf(list[_index]) !== -1) {
                  ishas = true
                }
              }
              if (ishas) {
                rt = 1
              }
            } else {
              // 单个
              rt = strUser[key].indexOf(_str)
            }
          }
        } else {
          rt = 0
        }
    }
  }
  return rt
}
Vue.prototype.getTimeNew = function (_time) {
  return _time != null ? new Date(_time.indexOf('T') < 0 ? _time.replace(/-/g, '/') : _time) : new Date()
}
Vue.prototype.getTimeUTC = function (_time) {
  const daterc = _time != null ? new Date(_time.indexOf('T') < 0 ? _time.replace(/-/g, '/') : _time) : new Date()
  let zoffset = daterc.getTimezoneOffset()
  const min = daterc.getMinutes()
  zoffset = summerTimeOffset(zoffset, '-')
  daterc.setMinutes(min + zoffset)
  return daterc
}
Vue.prototype.getTimeValue = function (_time, _format) {
  if (_time == null || _time.length < 11) {
    return _time
  }
  const daterc = new Date(_time.indexOf('T') < 0 ? _time.replace(/-/g, '/') : _time)
  return daterc.Format(_format)
}
// 0时间补时区 【2022.8.4】和夏令时
Vue.prototype.timeOffset = function (_time, _offset, mode) {
  if (_time == null || _time.length < 11) {
    return _time
  }
  let offset = _offset || store.state.projectinfor.ZoneOffset

  // 添加夏令时支持
  offset = summerTimeOffset(offset)

  const daterc = new Date(_time.indexOf('T') < 0 ? _time.replace(/-/g, '/') : _time)
  const min = daterc.getMinutes()
  const zoffset = offset || 0
  if (mode === '-') {
    daterc.setMinutes(min - zoffset)
  } else {
    daterc.setMinutes(min + zoffset)
  }
  // console.log(_time+"+"+offset+"_" + daterc.Format('yyyy-MM-dd HH:mm:ss'));
  return daterc.Format('yyyy-MM-dd HH:mm:ss')
}
// 补0
Vue.prototype.floatRepairZerotoSting = function (value, length) {
  if (!length) {
    length = 2
  }
  value = value + ''
  let zeros = ''
  for (let i = 0; i < length - value.length; i++) {
    zeros += '0'
  }
  return zeros + value
}
// 补0
Vue.prototype.stringRepairZero = function (value, length = 0) {
  let i = value.length
  if (i >= length) {
    value = value.substring(i - length, i)
  } else {
    let str0 = new Array(length + 1).join('0')
    value = str0.substring(0, str0.length - i) + value
    str0 = null
  }
  i = null
  return value
}
/**
 * 对数据进行排序
 * 规则如下
 * 所有涉及到多个设备的页面
 先按照大类是（网关，被控设备，控制设备）再按sku，再按首字母
 * 场景 / 自动化
 按创建时间 新的在上
 */
Vue.prototype.sortResult = function (type, result, key) {
  if (result == null || result[key] == null || result[key].length < 1) {
    return
  }
  if (type === 'device') {
    // 按大类分类
    let _result = []
    let gateway = []
    const accused = []
    let control = []
    let other = []
    result[key].forEach(item => {
      if (item.DeviceType === 1) {
        gateway.push(item)
      } else if (item.DeviceType === 2) {
        accused.push(item)
      } else if (item.DeviceType === 3) {
        control.push(item)
      } else {
        other.push(item)
      }
    })

    // 按排序(双重排序）先ClassSku 后DeviceName
    // var mSort = function (m, n) {
    //   if(m["ClassSku"] === n["ClassSku"]){
    //     if(m["DeviceName"] === n["DeviceName"]){
    //       // return m["ChildId"] - n["ChildId"];
    //       if (m["ChildId"] < n["ChildId"]) return -1;
    //       else if (m["ChildId"] > n["ChildId"]) return 1;
    //       else return 0;
    //     }
    //     // return m["DeviceName"] - n["DeviceName"];
    //     if (m["DeviceName"] < n["DeviceName"]) return -1;
    //     else if (m["DeviceName"] > n["DeviceName"]) return 1;
    //     else return 0;
    //   }
    //   // return m["ClassSku"] - n["ClassSku"];
    //   if (m["ClassSku"] < n["ClassSku"]) return -1;
    //   else if (m["ClassSku"] > n["ClassSku"]) return 1;
    //   else return 0;
    // }
    let mSort = function (m, n) {
      if (m.ClassSku.toString() < n.ClassSku.toString()) return -1
      else if (m.ClassSku.toString() > n.ClassSku.toString()) return 1
      else if (m.DeviceName.toString() < n.DeviceName.toString()) return -1
        else if (m.DeviceName.toString() > n.DeviceName.toString()) return 1
        else if (m.ChildId.toString() < n.ChildId.toString()) return -1
          else if (m.ChildId.toString() > n.ChildId.toString()) return 1
          else return 0;;
    }

    // var rr =  ["V2-2-1-中庭-1","V2-2-2-中庭-1","V2-2-1-中庭-10","V2-2-1-中庭-2","V2-2-4-中庭-1"];
    // console.log(Math.random() +" =  " +  rr.join("\n\r"));
    // rr.sort( (a,b) => {
    //   if(a<b)return -1
    //   else if(a<b)return 1
    //   else 0
    // });
    // console.log(Math.random() +" =  " +  rr.join("\n\r"));

    // 给大类进行双重排序
    gateway.sort(mSort)
    accused.sort(mSort)
    control.sort(mSort)
    other.sort(mSort)

    // 测试输出
    // gateway.forEach(item => {_result.push({"DeviceType":item["DeviceType"],"ClassSku":item["ClassSku"],"DeviceName":item["DeviceName"],"ChildId":item["ChildId"]})});
    // accused.forEach(item => {_result.push({"DeviceType":item["DeviceType"],"ClassSku":item["ClassSku"],"DeviceName":item["DeviceName"],"ChildId":item["ChildId"]})});
    // control.forEach(item => {_result.push({"DeviceType":item["DeviceType"],"ClassSku":item["ClassSku"],"DeviceName":item["DeviceName"],"ChildId":item["ChildId"]})});
    // 回笼
    gateway.forEach(item => {
      _result.push(item)
    })
    accused.forEach(item => {
      _result.push(item)
    })
    control.forEach(item => {
      _result.push(item)
    })
    other.forEach(item => {
      _result.push(item)
    })

    result[key] = _result
    // console.log(JSON.stringify(_result));

    _result = null
    gateway = null
    control = null
    other = null
    mSort = null
  } else if (type === 'scene') {
    let mTime, nTime
    result[key].sort(function (n, m) {
      mTime = new Date(m.CreateTime)
      nTime = new Date(n.CreateTime)
      if (mTime < nTime) {
        return -1
      } else if (mTime > nTime) {
        return 1
      } else {
        return 0
      }
    })
    mTime = null
    nTime = null
  } else if (type === 'ifttt') {
    let mTime, nTime
    result[key].sort(function (m, n) {
      if (m.IFtttType === n.IFtttType) {
        mTime = new Date(m.CreateTime)
        nTime = new Date(n.CreateTime)
        if (mTime < nTime) {
          return 1
        } else if (mTime > nTime) {
          return -1
        } else {
          return 0
        }
      }
      return n.IFtttType - m.IFtttType
    })
    mTime = null
    nTime = null
  }
}
/**
 * 找到国家名称 需要CountryCode
 */
Vue.prototype.findCountryName = function (CountryCode) {
  let _country = store.state.baseData
  _country = _country && _country.CountryList
  _country = _country && _country.find(item => {
    return item.CountryCode === CountryCode
  })
  if (_country != null) {
    return _country.CountryName || ''
  }
  _country = null
  return ''
}
/**
 * 弥补区域名称 需要Gpno
 */
Vue.prototype.makeUpAreaName = function (item) {
  if (item != null && item.AreaName == null && item.Gpno != null) {
    // item["AreaName"] = this.$store.state.areasGpName[item["Gpno"]];
    item.AreaName = store.state.areasGpName[item.Gpno]
    if (item.Gpno === 0) {
      item.AreaName = item.AreaName && item.AreaName.GpName
    }
  }
}
/**
 * 玻剥离照度值
 */
Vue.prototype.getpowertimeValue = function (item, key, value) {
  if (item.Value != null) {
    if (item.ParaUnit === 's') {
      if (item.Value !== '--') {
        item.Value = item.Value / 3600
        item.Value = item.Value.toFixed(1)
      }
      item.ParaUnit = 'h'
    }
  }
}
/**
 * 玻剥离温度值
 */
Vue.prototype.gettemperatureValue = function (item, key, value) {
  let illumination = item.Value
  if (illumination === '--') {
    return
  }
  if (typeof illumination === 'string' && JSON.isJSON(illumination)) {
    illumination = JSON.parse(illumination)
    // if(JSON.isJSON(illumination) == true){illumination = JSON.parse(illumination);}
  }
  if (illumination instanceof Object) {
    item.Value = illumination.OriginValue
    item.illumination = illumination.CorrectionValue
    item.IsCorrected = illumination.IsCorrected
    if (item.IsCorrected === true) {
      item.describtion = this.$t('deviceMsg.calibrateTempTip')
    } else if (item.IsCorrected === undefined && illumination.CorrectionValue != null && illumination.OriginValue !== illumination.CorrectionValue) {
      item.describtion = this.$t('deviceMsg.calibrateTempTip')
    } else {
      item.describtion = ''
    }
  }
  illumination = null
}
/**
 * 玻剥离照度值
 */
Vue.prototype.getilluminationValue = function (item, key, value) {
  let illumination = item.Value
  if (illumination === '--') {
    return
  }
  if (typeof illumination === 'string' && JSON.isJSON(illumination)) {
    illumination = JSON.parse(illumination)
    // if(JSON.isJSON(illumination) == true){illumination = JSON.parse(illumination);}
  }

  if (illumination instanceof Object) {
    item.Value = illumination.OriginValue
    item.illumination = illumination.CorrectionValue
    item.IsCorrected = illumination.IsCorrected
    if (item.IsCorrected === true) {
      item.describtion = this.$t('deviceMsg.calibrateLUXTip')
    } else if (item.IsCorrected === undefined && illumination.CorrectionValue != null && illumination.OriginValue !== illumination.CorrectionValue) {
      item.describtion = this.$t('deviceMsg.calibrateLUXTip')
    } else {
      item.describtion = ''
    }
  }
  illumination = null
}
// 卡片状态条：光子通量密度仅展示 0x1EFB，其余在设备详情等页面仍完整展示
Vue.prototype.isCardPhotonFluxStatusVisible = function (m) {
  const t = (m.StatusType || '').toUpperCase()
  return !['0X1EFC', '0X1EFD', '0X1EFE'].includes(t)
}

Vue.prototype.cardLightInforValue = function (m) {
  try {
    if (m.StatusType === '0x1A08' && !this.$store.state.programListConfig) {
      return ''
    }
      
    if (m.StatusType === '0x1401') {
      const status = {
        0:{
          name:'--'
        },
        1:{
          name:this.$t('deviceMsg.heating')
        },
        2:{
          name:this.$t('deviceMsg.refrigeration')
        },
        3:{
          name:this.$t('deviceMsg.dehumidification')
        },
        4:{
          name:this.$t('deviceMsg.airSupply')
        },
        5:{
          name:this.$t('deviceMsg.auto')
        }
      }

      return status[m.Value].name || '--'
    }
    //  总灯具模式&光模式
    if (m.StatusType === '0x1A02') {
      const status = {
        0:{
          name:this.$t('deviceMsg.lightMode3')
        },
        1:{
          name:this.$t('deviceMsg.lightMode4')
        },
        2:{
          name:this.$t('deviceMsg.lightMode5')
        },
      }
      return status[m.Value1].name || '--'
    }
    //上出光灯具模式&下出光灯具模式
    if (m.StatusType === '0x1E05' || m.StatusType === '0x1E02') {
      const status = {
        0:{
          name:this.$t('deviceMsg.lightMode1')
        },
        1:{
          name:this.$t('deviceMsg.lightMode2')
        },
      }
      return status[m.Value].name || '--'
    }
    if (m.StatusType === '0x1301') {
      const status = {
        0:{
          name:'--'
        },
        1:{
          name:this.$t('deviceMsg.airSupply')
        },
        2:{
          name:this.$t('deviceMsg.LSpeed')
        },
        3:{
          name:this.$t('deviceMsg.MSpeed')
        },
        4:{
          name:this.$t('deviceMsg.HSpeed')
        },
        5:{
          name:this.$t('deviceMsg.auto')
        }
      }
      return status[m.Value].name || '--'
    }
  } catch (error) {
  
  }
  
  if (['0x1A05', '0x1602'].includes(m.StatusType)) {
    console.log('m.Value', m.Value);
    
    const seconds = Number(m.Value);

    if (Number.isNaN(seconds)) return '--';

    if (seconds >= 3600) {
        return Number(moment.duration(seconds, 'seconds').asHours().toFixed(2)) + ' h';
    } else {
        return Number(moment.duration(seconds, 'seconds').asMinutes().toFixed(0))  + ' min';
    }
  }

  // 卡片上显示的亮度百分比
  if (m.StatusType != null && m.StatusType.indexOf('0x03') !== -1) {
    let _rtvalue
    if (m.Value === '--') {
      _rtvalue = m.Value
    } else {
      // const value = transLightToProp
      
      // Math.round(Number(m.Value) * 100 / 255);
      
      //  if(m.Value > 0 && m.Value < 3){m.Value = 3;}
      _rtvalue = transLightToProp(m.Value, 255);
    }
    return _rtvalue
  } else {
    if (m.StatusType === '0x0600' && m.Value instanceof Object) {
      m.Value = m.Value.OriginValue
      m.illumination = m.Value.CorrectionValue
      // m.IsCorrected = m.IsCorrected
    }
    return m.Value
  }
}
Vue.prototype.contorlLightInforValue = function (m, _value) {
  // 场景显示的亮度百分比
  if (m.Type != null && m.Type.indexOf('0x03') !== -1) {
    return isNaN(Math.ceil(Number(_value) * 100 / 255)) ? 0 : Math.ceil(Number(_value) * 100 / 255)
    //  return Math.round(Number(_value) * 100 / 255);
  } else {
    //  return m.Value;
    return Number(_value)
  }
}
Vue.prototype.rhythmlLightInforValue = function (_value) {
  // 节律恒照度返回
  //  return Math.round(Number(_value) * 100 / 255);
  return isNaN(Math.ceil(Number(_value) * 100 / 255)) ? 0 : Math.ceil(Number(_value) * 100 / 255)
}
Vue.prototype.rhythmlLightInforValueSubmit = function (_value) {
  // 节律恒照度提交
  //  return Math.round(Number(_value) / 100 * 255);
  return isNaN(Math.floor(Number(_value) * 255 / 100)) ? 0 : Math.floor(Number(_value) * 255 / 100)
}
Vue.prototype.socketLightActionValue = function (t, n) {
  // socket推送到action的亮度百分比显示
  if (t.Type != null && t.Type.indexOf('0x03') !== -1) {
    //  t.DefaultValue = Math.round(Number(n.Value) / t.Max_ * 100);
    t.DefaultValue = isNaN(Math.ceil(Number(n.Value) * 100 / t.Max_)) ? 0 : Math.ceil(Number(n.Value) * 100 / t.Max_)
  } else {
    t.DefaultValue = Number(n.Value)
  }
}

Vue.prototype.LightActionValueReady = function (model, i) {
  // console.log('LightActionValueReady', i,  model.Values, model.Values[i].DefaultValue);

  // action准备好后格式化数据
  if (model.Values[i].Type != null && model.Values[i].Type.indexOf('0x03') !== -1) {
    console.log('LightActionValueReady', model.Values[i].Type);
    
    model.Values[i].DefaultValue_ = Number(model.Values[i].DefaultValue)
    model.Values[i].Min_ = Number(model.Values[i].Min)
    model.Values[i].Max_ = Number(model.Values[i].Max)
    //  model.Values[i].DefaultValue = Math.round(Number(model.Values[i].DefaultValue_)/Number(model.Values[i].Max_)*100);
    // 修改亮度值格式化方式
    const typeKey = 'ceil'; 

    model.Values[i].DefaultValue = isNaN(Math[typeKey](Number(model.Values[i].DefaultValue_) * 100 / Number(model.Values[i].Max_))) ? 0 : Math[typeKey](Number(model.Values[i].DefaultValue_) * 100 / Number(model.Values[i].Max_))
    model.Values[i].Min = isNaN(Math.ceil(Number(model.Values[i].Min_) * 100 / Number(model.Values[i].Max_))) ? 0 : Math.ceil(Number(model.Values[i].Min_) * 100 / Number(model.Values[i].Max_))
    model.Values[i].Max = 100
    console.log('model.Values[i]', model.Values[i]);
    
  } else if (model.Values[i].ValueType === 'UIControl_ColorPanel') {
      model.Values[i].DefaultValue_ = Number(model.Values[i].DefaultValue)
      model.Values[i].DefaultValue = '#' + model.Values[i].DefaultValue_.toString(16)
    }
}
// jump 加于20230609 用于区分场景同步初始数据，jump用于跳过处理最大值最小值（重复处理了）
Vue.prototype.LightActionValueEditorReady = function (p, t,jump=false) {

  // action准备好后格式化数据-foreach
  if (p.Type != null && p.Type.indexOf('0x03') !== -1) {
    p.DefaultValue_ = Number(t.Value)
    if(!jump){
      p.Min_ = Number(p.Min)
      p.Max_ = Number(p.Max)
      p.Min = isNaN(Math.round(p.Min_ * 100 / p.Max_)) ? 0 : Math.round(p.Min_ * 100 / p.Max_)
      p.Max = 100
    }
    
    //  t.Value=Math.round(p.DefaultValue_/p.Max_*100);
    t.Value = isNaN(Math.round(p.DefaultValue_ * 100 / p.Max_)) ? 0 : Math.round(p.DefaultValue_ * 100 / p.Max_)
  } else if (p.ValueType === 'UIControl_ColorPanel') {
      p.DefaultValue_ = Number(t.Value)
      t.Value = '#' + p.DefaultValue_.toString(16)
      p.DefaultValue = t.Value
    }
}
Vue.prototype.LightActionValueSubmit = function (tem) {
  
  // action准备下发格式化数据
  if (tem.Type != null && tem.Type.indexOf('0x03') !== -1) {
    if (tem.Max_ != null) {
      return Math.floor(tem.DefaultValue * tem.Max_ / 100)
    } else {
      return Math.floor(tem.DefaultValue * 255 / 100)
    }
  } else if(tem.Type != null && tem.Type.indexOf('0x1E1F') !== -1){
    //针对倍速
    return tem.DefaultValue * 10
  }
  else if (typeof tem.DefaultValue === 'string' && tem.DefaultValue.indexOf('#') >= 0) {
      return parseInt('0x' + tem.DefaultValue.substr(1))
    } else {
      return tem.DefaultValue
    }
}
Vue.prototype.GetStatusAbilityTranslate = function (doFun, m, _key, _name, isReturn) {
  // action准备下发格式化数据
  const key = _key || 'Key'
  const name = _name || 'name'
  if (doFun != null && m != null && m[key] != null && m[key].length >= 4) {
    if (m[key].toUpperCase() === '0X0102') {
      m[name] = 'uplink'
    } else if (m[key].toUpperCase() === '0X0103') {
      m[name] = 'wifi'
    } else if (m[key].toUpperCase() === '0X0104') {
      m[name] = 'ble'
    } else if (m[key].toUpperCase() === '0X0105') {
      m[name] = 'dali'
    } else if (m[key].toUpperCase() === '0X0106') {
      m[name] = '485'
    } else if (m[key].toUpperCase().substring(0, 4) === '0X02') {
      m[name] = doFun('devicecard.switchstatus')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X03') {
      m[name] = doFun('devicecard.light')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X04') {
      m[name] = doFun('devicecard.colortemperature')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X05') {
      m[name] = doFun('devicecard.movement')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X06') {
      m[name] = doFun('devicecard.illuminance')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X07') {
      m[name] = doFun('devicecard.temperature')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X08') {
      m[name] = doFun('devicecard.humidity')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X09') {
      m[name] = doFun('devicecard.co2')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X0A') {
      m[name] = doFun('devicecard.pm')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X0B') {
      m[name] = 'tvoc'
    } else if (m[key].toUpperCase().substring(0, 4) === '0X0C') {
      m[name] = doFun('devicecard.energyconsumption')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X0D') {
      m[name] = doFun('devicecard.energyconsumption')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X0E') {
      m[name] = doFun('devicecard.remaininglife')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X0F') {
      m[name] = doFun('devicecard.motortravel')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X10') {
      m[name] = doFun('devicecard.electricity')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X12') {
      m[name] = doFun('devicecard.motorangle')
    }
    if (isReturn === true) {
      return m[name] || ''
    }
  }
}
Vue.prototype.GetStoreCacheObj = function (storeName, tag) {
  let item = getLocalStoragItem(storeName)
  item = item && JSON.parse(item)
  if (item != null && item[tag] != null) {
    return item[tag]
  } else {
    return null
  }
}
Vue.prototype.SetStoreCacheObj = function (storeName, tag, param) {
  let item = getLocalStoragItem(storeName)
  item = item && JSON.parse(item)
  item = item || {}
  item[tag] = param
  setLocalStoragItem(storeName, JSON.stringify(item))
}
Vue.prototype.DelStoreCacheObj = function (storeName, tag) {
  if (tag === undefined) {
    setLocalStoragItem(storeName, JSON.stringify({}))
  }
  let item = getLocalStoragItem(storeName)
  item = item && JSON.parse(item)
  if (item != null && item[tag] != null) {
    delete item[tag]
    setLocalStoragItem(storeName, JSON.stringify(item))
  }
}
Vue.prototype.datapickerLimit = function (param, type, num) {
  const min = new Date(param[0])
  min.setMonth(min.getMonth() + 1)
  const max = new Date(param[1])
  return min.getTime() <= max.getTime()
}

// 目标值取整 （直接处理 或者 条件处理）
Vue.prototype.dataFormatInt = function (isdo, value, tag, model, key, typeValue) {
  if (value != null && tag != null && typeof value[tag] === 'number') {
    if (isdo === true) {
      value[tag] = parseInt(value[tag])
    } else if (model != null && key != null && model[key] != null && model[key].indexOf(typeValue) !== -1) {
        value[tag] = parseInt(value.DefaultValue)
      }
  }
}
Vue.prototype.createuuid = function () {
  const _systemjsuuid = createSystemGuid()
  setLocalStoragItem('systemjsuuid', _systemjsuuid)
  return _systemjsuuid
}

Vue.prototype.getuuid = function () {
  return getLocalStoragItem('systemjsuuid')
}

// 补区域名称
Vue.prototype.getParentAreaNames = function (parentGpnos) {
  if (parentGpnos != null && parentGpnos !== '') {
    const _result = []
    let _item = parentGpnos.split(',')
    let _param
    if (_item != null) {
      _item.forEach(param => {
        if (param.substring(0, 1) === '@') {
          _param = param.substring(1, param.length)
        }
        if (_param.substr(_param.length - 1, 1) === '@') {
          _param = _param.substring(0, _param.length - 1)
        }
        _param = store.state.areasGpName[_param]
        _param = _param && _param.GpName
        _result.push(_param)
      })
    }
    _item = null
    _param = null
    return _result.reverse().join(',')
  }
}
// 合并对象方法 实现 extend
Vue.prototype.extend = function () {
  const length = arguments.length
  let target = arguments[0] || {}
  if (typeof target !== 'object' && typeof target !== 'function') {
    target = {}
  }
  let i = 1
  if (length === 1) {
    target = this
    i--
  }
  for (i; i < length; i++) {
    const source = arguments[i]
    for (const key in source) {
      // 使用for in会遍历数组所有的可枚举属性，包括原型。
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key]
      }
    }
  }
  return target
}

/* 格式化设备trigger数据 赋值
 */
Vue.prototype.deviceTriggerFilter = function (triggerArry, trigger, is_action, is_enable, compareArray) {
  let curIndex = -1
  let _model
  triggerArry.forEach((model, index) => {
    // model["enable"] = true;
    model.ischeck = false
    if (model.ExtraKeyId === trigger.ExtraKeyId && model.OperationValue === trigger.OperationValue) {
      model.DefaultValue = trigger.DefaultValue
      curIndex = index
      if (is_action === true) {
        model.ischeck = true
      }
    }

    if (is_enable === true) {
      if (model.ExtraKeyId !== trigger.ExtraKeyId) {
        _model = compareArray.find(item => {
          return model.MsgID === item.triggle.MsgID && model.KeyID === item.triggle.KeyID && model.ExtraKeyId === item.triggle.ExtraKeyId
        })
        if (_model != null) {
          model.enable = true
        }
      }
    }
  })
  return curIndex
}
/**
 * 格式化设备action数据 赋值
 * @param {*} actionArry 
 * @param {*} valueArry 
 * @param {*} ischeck 是否需要有选中状态-----默认为true
 */
Vue.prototype.deviceActionFilter = function (actionArry, valueArry, ischeck= true) {
  // 筛选数组 将不显示的对象去除  DefaultValue格式化转成int
  let valueArryMsg
  let actionArryValue, valueArryValue, valueObj
  actionArry.forEach(model => {
    for (let i = 0; i < valueArry.length; i++) {
      actionArryValue = null
      valueArryMsg = valueArry[i]
      if (valueArryMsg.MsgType === model.MsgType
        //  && valueArryMsg["Reserve"] == model["Reserve"]
      ) {
        actionArryValue = model.Values
        if (actionArryValue instanceof Array && actionArryValue.length > 0) {} else {
          actionArryValue = null
        }
        break
      }
    }
    if (actionArryValue != null) {
      valueArryValue = valueArryMsg.Values
      if (valueArryValue instanceof Array && valueArryValue.length > 0) {
        actionArryValue.forEach(value => {
          valueObj = valueArryValue.find(valueObj => {
            return valueObj.KeyId === value.KeyId
          })
          if (valueObj != null) {
            if(!ischeck){
                if (value.ValueType === 'UIControl_RGB_Color_Multiple_Choose') {
                  value.DefaultValue = valueObj.DefaultValue
                } else if (value.ValueType === 'UIControl_MultipleDropdownList') {
                  value.DefaultValue = valueObj.DefaultValue.split(',')
                } else if (value.ValueType === 'UIControl_ColorPanel' || UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY.includes(value.ValueType)) {
                  value.DefaultValue = valueObj.DefaultValue
                } else {
                  value.DefaultValue = Number(valueObj.DefaultValue)
                }
            }


            if(ischeck){
              value.DefaultValue = valueObj.DefaultValue
              model.ischeck = true
            }
           
          }
        })
      }
    }
  })
}

Vue.prototype.showDeviceVersion = function (classsku, version) {
  if (classsku == null) {
    return version
  }
  let _sku = this.findDeviceCategory(classsku)
  if (_sku != null) {
    if (_sku != null && _sku.DeviceType === 1) {
      _sku = null
      return this.formatEdition(version)
    } else {
      _sku = null
      return '0x' + version.toString(16)
    }
  }
  _sku = null
  return version
}
// /**
//  *
//  * @param {vue空间} that
//  * @param {接口数据} item
//  * @param {状态 relate | on | offline | off} type
//  */
// Vue.prototype.getClassSkuImage = function(that, item, type){
//   // $icons(msg.ClassSku)?$icons(msg.ClassSku).off:'';
//
//   if(that == null){return '';}
//   // if(that.$store.state.isLocalServer != true && item["IconUrl"].indexOf("http")>=0){
//     // return item["IconUrl"][type] || '';
//   // }
//   var imageUrl;
//   imageUrl = item && item.ClassSku;
//   imageUrl = imageUrl && that.$icons(imageUrl);
//   imageUrl = imageUrl && imageUrl[type];
//   return imageUrl;
//
// }
Vue.prototype.getClassSkuImage = function (item, type) {
  return getClassSkuImages(this, item, type)
}

Vue.prototype.findDeviceCategory = function (classsku) {
  let result = store.state.deviceCategoryList
  if (result != null) {
    result = result.find(param => {
      return param.ClassSku === classsku
    })
    return result
  } else {
    result = null
    return null
  }
}

Vue.prototype.findDeviceCategorys = function (list) {
  if (list != null && list instanceof Array) {
    let result = store.state.deviceCategoryList
    const _list = []
    let obj
    if (result != null) {
      list.forEach(classsku => {
        obj = result.find(param => {
          return param.ClassSku === classsku
        })
        if (obj != null && obj.Name != null) {
          _list.push(obj.Name)
        }
      })
      result = null
      obj = null
      return _list
    }
  }
  return ''
}

Vue.prototype.findChildCategoryType = function (Value) {
  let result = store.state.baseData.ChildCategoryTypeList
  if (result != null) {
    result = result.find(param => {
      return param.Value === Value
    })
    return result
  } else {
    result = null
    return null
  }
}

Vue.prototype.findBaseDataList = function (BaseDataKey, Value, ValueKey) {
  let result = store.state.baseData[BaseDataKey]
  if (Value != null) {
    if (result != null) {
      result = result.find(param => {
        return param.Value === Value
      })
      if (ValueKey != null) {
        return result ? result[ValueKey] : null;
      } else {
        return result
      }
    } else {
      result = null
      return null
    }
  } else {
    return result
  }
}

Vue.prototype.doGetStatusAbilityTranslate = function (doFun, m, _key, _name, isReturn) {
  // action准备下发格式化数据
  let key = _key || 'Key'
  let name = _name || 'name'
  if (doFun != null && m != null && m[key] != null && m[key].length >= 4) {
    if (m[key].toUpperCase() === '0X0102') {
      m[name] = 'uplink'
    } else if (m[key].toUpperCase() === '0X0103') {
      m[name] = 'wifi'
    } else if (m[key].toUpperCase() === '0X0104') {
      m[name] = 'ble'
    } else if (m[key].toUpperCase() === '0X0105') {
      m[name] = 'dali'
    } else if (m[key].toUpperCase() === '0X0106') {
      m[name] = '485'
    } else if (m[key].toUpperCase().substring(0, 4) === '0X02') {
      m[name] = doFun('devicecard.switchstatus')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X03') {
      m[name] = doFun('devicecard.light')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X04') {
      m[name] = doFun('devicecard.colortemperature')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X05') {
      m[name] = doFun('devicecard.movement')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X06') {
      m[name] = doFun('devicecard.illuminance')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X07') {
      m[name] = doFun('devicecard.temperature')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X08') {
      m[name] = doFun('devicecard.humidity')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X09') {
      m[name] = doFun('devicecard.co2')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X0A') {
      m[name] = doFun('devicecard.pm')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X0B') {
      m[name] = 'tvoc'
    } else if (m[key].toUpperCase().substring(0, 4) === '0X0C') {
      m[name] = doFun('devicecard.energyconsumption')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X0D') {
      m[name] = doFun('devicecard.energyconsumption')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X0E') {
      m[name] = doFun('devicecard.remaininglife')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X0F') {
      m[name] = doFun('devicecard.motortravel')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X10') {
      m[name] = doFun('devicecard.electricity')
    } else if (m[key].toUpperCase().substring(0, 4) === '0X12') {
      m[name] = doFun('devicecard.motorangle')
    }
    if (isReturn === true) {
      return m[name] || ''
    }
    key = null
    name = null
  }
}
/**
 * 匹配状态名称
 */
Vue.prototype.deiveStatusName = function (key, value) {
  let _deviceStatus = store.state.deiveStatus
  let result = ''
  if (_deviceStatus != null && _deviceStatus instanceof Array && _deviceStatus.length && key != null && value != null) {
    let i = 0
    let l = _deviceStatus.length
    let _obj
    for (; i < l; i++) {
      _obj = _deviceStatus[i]
      if (key === _obj.Key) {
        _obj = _obj.Value
        if (_obj != null && _obj instanceof Array && _obj.length) {
          _obj = _obj.find(param => {
            return param.Value === value
          })
          if (_obj != null) {
            result = _obj.Key || ''
            break
          }
        } else {
          break
        }
      }
    }
    i = null
    l = null
    _obj = null
  }
  _deviceStatus = null
  return result
}

/* 格式化时间
 */
Vue.prototype.formatetime = function (row, column, cellValue, index) {
  if (cellValue === '' || cellValue == null) {
    return ''
  }
  const daterc = new Date(cellValue)
  let datercTime = daterc.Format('yyyy-MM-dd HH:mm:ss')
  let min = daterc.getMinutes()
  let zoffset = row.ZoneOffset || 0
  daterc.setMinutes(min + zoffset)
  // console.log("LogEvent [POST-Response]→Date.format" + row["ProjectCode"] + ">> "+ datercTime + " "+zoffset+"m = "+daterc.Format('yyyy-MM-dd HH:mm:ss'));
  min = null
  zoffset = null
  datercTime = null
  return daterc.Format('yyyy-MM-dd')
}
// 检验邮箱
Vue.prototype.checkEmail = function (value) {
  // const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+(\.[a-zA-Z0-9_-]+)@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
  const regEmail = /^[\u4e00-\u9fa5a-zA-Z\d]+([-_.][\u4e00-\u9fa5A-Za-z\d]+)*@([\u4e00-\u9fa5A-Za-z\d]+[-.]){1,2}[\u4e00-\u9fa5A-Za-z\d]{2,5}$/g
  return regEmail.test(value)
}
// 检验手机
Vue.prototype.checkMobile = function (value) {
  // const regEmail = /^(0|86|17951)?(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/;
  // return /^1[34578]\d{9}$/.test(value);
  return checkMobile(value)
}
// 空调温度设置
Vue.prototype.conditionerSetTemperature = function (type, item, key) {
  if (type === '+') {
    if (item.Max != null) {
      if (item.Max > item.DefaultValue) {
        item.DefaultValue += 1
      }
    } else {
      item.DefaultValue += 1
    }
  } else if (type === '-') {
    if (item.Min != null) {
      if (item.Min < item.DefaultValue) {
        item.DefaultValue -= 1
      }
    } else {
      item.DefaultValue -= 1
    }
  }
}
// 空调温度设置 conditionerFindActionKey("0x03110000B")
Vue.prototype.conditionerFindActionKey = function (item, msgType, keyValue) {
  if (item != null) {
    let ci = 0
    let cl = item.length
    let co
    for (; ci < cl; ci++) {
      co = item[ci]
      if (co instanceof Array) { // 兼容性写法
        co = co[0]
      }
      co = co && co.ActionList
      if (co != null) {
        co = co.find(param => {
          return param.MsgType === msgType
        })
        if (co != null) {
          co = co.Values
          co = co[0]
          if (co.DefaultValue == keyValue) {
            ci = null
            cl = null
            co = null
            return true
          } else {
            ci = null
            cl = null
            co = null
            return false
          }
        }
      }
    }
    ci = null
    cl = null
    co = null
  }
  return false
}
// 滚动设备卡片 - 策略核算所见卡片
Vue.prototype.scrollEventDoShowCardList = function (param, cardlist) {
  let _target = param.target
  let scrollHeight = _target.scrollTop
  let scrollWidth = _target.offsetWidth
  let clientHeight = _target.parentElement.parentElement.parentElement.parentElement.parentElement
  clientHeight = clientHeight.offsetHeight
  let scrollSize = scrollWidth * scrollHeight
  // var sourSize = (261 + 10 + 2) * (233 + 12);
  // var sourWidthNum = scrollWidth / (261 + 10 + 2);
  // var sourHeightNum = scrollHeight / (233 + 12);
  // var clientHeightNum = clientHeight / (233 + 12);
  let sourSize = (261 - 32 + 10 + 2) * (233 - 16 + 12)
  let sourWidthNum = scrollWidth / (261 - 32 + 10 + 2)
  let sourHeightNum = scrollHeight / (233 - 16 + 12)
  let clientHeightNum = clientHeight / (233 - 16 + 12)
  sourWidthNum = Math.floor(sourWidthNum)
  sourHeightNum = Math.floor(sourHeightNum)
  clientHeightNum = Math.floor(clientHeightNum)
  const tagIndexStart = sourWidthNum * sourHeightNum
  let tagIndexLength = sourWidthNum * clientHeightNum
  // if (clientHeight % (233 + 12) > 0) { tagIndexLength += sourWidthNum;}
  // if (scrollHeight % (233 + 12) > clientHeight % (233 + 12)) {tagIndexLength += sourWidthNum;}
  if (clientHeight % (233 - 16 + 12) > 0) {
    tagIndexLength += sourWidthNum
  }
  if (scrollHeight % (233 - 16 + 12) > clientHeight % (233 - 16 + 12)) {
    tagIndexLength += sourWidthNum
  }
  _target = null
  scrollHeight = null
  scrollWidth = null
  clientHeight = null
  scrollSize = null
  sourSize = null
  sourWidthNum = null
  sourHeightNum = null
  clientHeightNum = null
  return cardlist.slice(tagIndexStart, tagIndexStart + tagIndexLength)
}
// 添加空调能力测试数据
Vue.prototype.addAirConditionActionAbilityTest = function (item, isParentStructure) {

  // const _data = {
  //   MsgType: '0x03110000A',
  //   Reserve: '0x00000000',
  //   Desc: '空调设置',
  //   ShowMode: 3,
  //   Values: [{
  //     KeyId: 1,
  //     ValueType: 'UIControl_AC_Temperature',
  //     Name: '空调温度',
  //     DefaultValue: '27',
  //     EnumValue: [{
  //       Name: '自动化',
  //       Value: 1
  //     }, {
  //       Name: '高',
  //       Value: 2
  //     }, {
  //       Name: '中',
  //       Value: 3
  //     }, {
  //       Name: '低',
  //       Value: 4
  //     }],
  //     IsShow: true,
  //     HasStatusValue: true,
  //     Type: '0x0207',
  //     IsTriggerButton: false,
  //     Min: -30,
  //     Max: 30,
  //     Extra1: '',
  //     ParaUnit: '',
  //     ParaType: 'U8'
  //   }],
  //   Selected: false
  // }
  // if (isParentStructure) {
  //   item.push({
  //     ChannelId: 0,
  //     ActionList: [_data]
  //   })
  // } else {
  //   item.push(_data)
  // }
}

// 移动指定key指定值的对象 至 数值最后。
Vue.prototype.arrayMoveKeyToEnd = function (arr, key, value) {
  let y = 0 // 定义y用于控制循环结束
  for (let i = 0; y < arr.length; y++) {
    if (arr[i][key] === value) arr.push(arr.splice(i, 1)[0]) // 循环到是0的位置就删除该元素0并且在arr末尾push进这个元素0，由于splice删除了该位置元素，所以i不用+1，下次循环仍然检查i位置的元素
    else i++ // 循环到不是0的位置就继续往后循环
  }
  return arr // 返回操作后的原数组
}

// 版本 网关 00.00.00
Vue.prototype.formatEdition = function (param) {
  if (param === 0 || param === '') {
    return param
  }
  let _param = param.toString(16)
  _param = _param.replace(/(.{2})/g, '$1.')
  _param = _param.substring(0, _param.length - 1)
  return _param
}
// 不0
Vue.prototype.formatEdition = function (param) {
  if (param === 0 || param === '') {
    return param
  }
  let _param = param.toString(16)
  _param = this.stringRepairZero(_param, 6)
  _param = _param.replace(/(.{2})/g, '$1.')
  _param = _param.substring(0, _param.length - 1)
  return _param
}
/**
 * 自动化对所选设备的能力数据进行排序（触发规则，下发规则）
 */
Vue.prototype.iftttCustomSetRuleSort = function (array) {
  iftttCustomSetRuleSort(array)
}
// 深度拷贝
Vue.prototype.deepClone = function (origin, _target) { // 传入参数
  const target = _target || {} // 防止没有写接收克隆的目标，所以兼容一下，如果没有就用空对象去接收
  const toStr = Object.prototype.toString // 把原型上的toString付给toStr
  const arrStr = '[object Array]'
  for (const prop in origin) { // 循环起源对象
    if (origin.hasOwnProperty(prop)) { // 不拿原型上的东西，如果有原型上的属性就不进入判断 为什么不用Object.keys()
      if (origin[prop] !== null && origin[prop] !== 'null' && typeof origin[prop] === 'object') { // 不拿起源对象上面为空的值，拿原始值
        if (toStr.call(origin[prop]) === arrStr) { // 为数组否则为对象
          target[prop] = [] // 创建空数组接收
        } else {
          target[prop] = {} // 创建空对象接收
        }
        Vue.prototype.deepClone(origin[prop], target[prop]) // 再传入参数，执行递归，重复判断这整个流程
      } else {
        target[prop] = origin[prop] // 如果是应用值直接付给目标
      }
    }
  }
  return target // 防止没写接收的目标，返回克隆完成后的目标
}

Vue.prototype.getAppShowMode = function (tem, type) {
  return getAppShowMode(tem, type)
}
Es6Promise.polyfill()
/* eslint-disable no-new */


async function bootstrap() {
  const { shouldMountVue } = await initXingCheng();
  if (!shouldMountVue) {
    console.log('🚫 星辰预加载，不启动 Vue');
    return;
  }
  new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})
  
}



bootstrap()

function getFinalStr (_str) {
  return '|' + store.state.powerPerfix + _str + '|'
  // return "|Opple_"+_str+"|";
}

// 限制按钮点击事件，在结果返回以前不能继续点击
Vue.directive('btn-control', {
  // 插入dom 时做的事情
  inserted: function (el, bind) {
    el.addEventListener('click', () => {
      el.disabled = true
      bind.value().then(res => {
        el.disabled = false
      })
    })
  }
});
(function () {
  let openDelay = false
  Vue.directive('intervalclick', function (el, binding) {
    el.onclick = function (e) {
      if (openDelay) return
      openDelay = !openDelay
      if (!binding.value) {
        alert('Input Value No Data！')
        return
      }
      const func = binding.value.func
      const time = binding.value.time || 1000
      if (typeof time !== 'number') {
        alert('Waitting Time is Error')
        return
      }
      const args = []
      for (const key in binding.value) {
        if (binding.value.hasOwnProperty(key)) {
          if (key === 'func' || key === 'time') continue
          args.push(binding.value[key])
        }
      }
      setTimeout(() => {
        openDelay = !openDelay
      }, time)
      func(...args)
    }
  })
})()

Vue.prototype.getNewStatusName = function (d) {
  let data = d;

  if (typeof data === 'string' && data) {
    try {
      data = JSON.parse(data)
    } catch (e) {

    }
  }

  return (data || { Name: ''}).Name;
}
